<span class="view-stats title">{{ title$ | async | titlecase }}</span>

<span class="view-stats dimensions">{{ dimensions$ | async }}</span>

<fa-icon
  *ngIf="(axis$ | async) !== 1"
  class="view-stats icon"
  [icon]="(axis$ | async) ? faLongArrowAltUp : faLongArrowAltRight"
  size="2x"
></fa-icon>

<h3-auto-ground-button
  *ngIf="
    axis === 1 && (isReadOnly$ | async) === false && (isLeftEditPanel$ | async)
  "
  class="view-stats"
>
</h3-auto-ground-button>
